module.exports = __webpack_public_path__ + "static/AvenirNext-Medium-e36657ad1576d30ec1dd099264800cee.woff";